import BusinessIcon from "@mui/icons-material/Business";
import { Grid, IconButton, TextField, Typography } from "@mui/material";
import { t } from "i18next";
import { Controller } from "react-hook-form";

export function BusinessDataFields({
    register,
    control,
    showFieldsName = "showJdgFields",
    showInitially = false,
}) {
    return (
        <>
            <Grid item sx={{ mt: 2 }}>
                <Grid container direction="row" alignItems="center">
                    <Typography variant="subtitle1" sx={{ mr: 1, fontWeight: "medium" }}>
                        {t("clients.ClientPassportDialog.businessData")}
                    </Typography>
                    <Controller
                        control={control}
                        name={showFieldsName}
                        defaultValue={showInitially}
                        render={({ field }) => (
                            <IconButton
                                color={field.value ? "primary" : "default"}
                                onClick={() => field.onChange(!field.value)}
                                title={t("clients.ClientPassportDialog.toggleBusinessData") || ""}
                                size="small"
                            >
                                <BusinessIcon />
                            </IconButton>
                        )}
                    />
                </Grid>
            </Grid>
            <Controller
                control={control}
                name={showFieldsName}
                defaultValue={showInitially}
                render={({ field }) => (
                    <>
                        {field.value && (
                            <>
                                <Grid item sx={{ mt: 1 }}>
                                    <TextField
                                        {...register("jdgNip")}
                                        fullWidth
                                        label={t("clients.ClientPassportDialog.nip")}
                                        size="small"
                                        placeholder="0000000000"
                                    />
                                </Grid>
                                <Grid item sx={{ mt: 2 }}>
                                    <TextField
                                        {...register("jdgRegon")}
                                        fullWidth
                                        label={t("clients.ClientPassportDialog.regon")}
                                        size="small"
                                        placeholder="000000000"
                                    />
                                </Grid>
                                <Grid item sx={{ mt: 2 }}>
                                    <TextField
                                        {...register("jdgCompanyName")}
                                        fullWidth
                                        label={t("clients.ClientPassportDialog.companyName")}
                                        size="small"
                                    />
                                </Grid>
                            </>
                        )}
                    </>
                )}
            />
        </>
    );
}
